import { persistStore } from 'redux-persist'
import { store } from '../redux/store'
export const persistor = persistStore(store)
